import useNetwork from './network';
import { IProviderModel } from './models/providerModel';

export const updateProviders = async (lang: string, id: string, details: IProviderModel[]) => {
    const { updateProviders } = useNetwork();
    const result = await updateProviders(lang, id, details);

    if (result.status === 200) {
        return (await result.json()) as IProviderModel[];
    }
};
